module.exports = __webpack_public_path__ + "static/media/arrow-down-blue.a0b27085.svg";